/*
 * Fonctions globales au site
 */

/*
 * Ajoute les différentes propriétés aux liens
 */
jQuery(document).ready(function () {
    var base = jQuery('base')[ 0 ].href;
    // Blank sur les liens externes
    jQuery('a[href^=http]:not([href^="' + base + '"])').prop('target', '_blank').prop('rel', 'noopener');
    // Gérer les liens retour
    jQuery('body').on('click', 'a.retour', function () {
        if (document.referrer.indexOf(location.protocol + '//' + location.hostname) == 0) {
            history.back();
            return false;
        }
    });
    // Detection de la souris
    window.addEventListener('mouseover', function onFirstHover() {
        jQuery('html').addClass('has-mouse');
        window.removeEventListener('mouseover', onFirstHover, false);
    }, false);

    // Rajouter le base href aux liens qui n'ont qu'une ancre
    jQuery('a[href^="#"]').each(function (index, link) {
        link.href = window.location.pathname + jQuery(link).attr('href');
    });

    jQuery('body').on('click', '.button_share', function () {
        jQuery(".social_item").toggleClass("clicked");
    });

    jQuery('body').on('click', 'a.print, .print a', function (e) {
        window.open(addtpl(window.location.href, 'print'));
        return false;
    });

    jQuery('body').on('click', '.confirm', function (ev) {
        if (!confirm(jQuery(this).prop('title') + '\n\nVous confirmez ?')) {
            ev.preventDefault();
        }
    });

    jQuery('body').on('click', '.rte a[href$="jpg"], .rte a[href$="jpeg"], .rte a[href$="png"], .rte a[href$="gif"]', function (ev) {
        let $this = jQuery(this);
        jQuery('#image-zoom-img').prop("src", $this.prop('href'));
        jQuery('#image-zoom-legend').html($this.prop('title'));
        let myModal = new bootstrap.Modal(document.getElementById('image-zoom-modal'));
        myModal.show();
        ev.preventDefault();
    });

    jQuery('body').on('click', 'a[target=popup]:not([href*=upload])', function (ev) {
        if (jQuery('#content-popup #content-popup-body').length == 0) {
            return;
        }
        let title = jQuery(this).data('title') || jQuery(this).prop('title') || jQuery(this).text();
        let contentSelector = jQuery(this).data('selector') || '';
        jQuery.ajax(addtpl(this.href, jQuery(this).data('tpl') || 'contenu')).done(function (data) {
            if (contentSelector) {
                jQuery('#content-popup-body').html(jQuery(data).find(contentSelector));
            } else {
                jQuery('#content-popup-body').html(data);
            }
            jQuery('#content-popup-title').html(title);
            let myModal = new bootstrap.Modal(document.getElementById('content-popup'));
            myModal.show();
        });
        ev.preventDefault();
    });
    let lastClicked = null;
    jQuery('body').on('click', 'a[data-target]:not([href*=upload])', function (ev) {
        let callee = jQuery(this);
        let target = jQuery('#' + callee.data('target'));
        if (target.length == 0) {
            return;
        }
        let fragment = callee.data('fragment') || 'preview';
        let toggleClass = callee.data('toggle') || '';
        if (toggleClass && lastClicked) lastClicked.toggleClass(toggleClass);
        target.load(addtpl(this.href, callee.data('tpl') || 'contenu #' + fragment), [], function() {
            // Toggle item class if asked
            if (toggleClass) {
                callee.toggleClass(toggleClass);
                lastClicked = callee;
            }
            // Scroll to target
            this.scrollIntoView(true);
        });
        ev.preventDefault();
    });
});

/**
 * Permet d'ajouter un tpl à l'url passée en paramètre
 * @param  url Url à modifier
 * @param  tpl Nom du template à ajouter
 * @returns string url modifiée
 */
global.addtpl = function (url, tpl) {
    url = url.replace(/#.*/, '');
    if (url.indexOf('tpl=') != -1)
        return url.replace(/tpl=[^&]+/, 'tpl=' + tpl);
    if (url.indexOf('?') == -1)
        return url + '?tpl=' + tpl;
    else
        return url + '&tpl=' + tpl;
}

/* Ajout aux favoris */
global.addToFavorites = function (link) {
    pageTitle = document.title;
    pageURL = document.location;
    if (typeof window.external.AddFavorite != "undefined") {
        // Internet Explorer solution
        window.external.AddFavorite(pageURL, pageTitle);
    } else if (typeof window.sidebar != "undefined" && typeof window.sidebar.addPanel != "undefined") {
        // Mozilla Firefox solution
        window.sidebar.addPanel(pageTitle, pageURL, "");
    } else {
        // Opera solution
        if (typeof ( opera ) == "object") {
            link.rel = "sidebar";
            link.title = pageTitle;
            link.url = pageURL;
            return true;
        } else {
            // The rest browsers (i.e Chrome, Safari)
            alert('Appuyer sur ' + ( navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'Cmd' : 'Ctrl' ) +
                '+D Pour ajouter cette page à vos favoris.');
        }
    }
    return false;
}

